"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const vuex_1 = tslib_1.__importDefault(require("vuex"));
const api_1 = require("../api");
const ChallengeType_1 = require("../enums/ChallengeType");
const Workflow_1 = require("../enums/Workflow");
const ChallengeStatus_1 = require("../enums/ChallengeStatus");
vue_1.default.use(vuex_1.default);
exports.default = new vuex_1.default.Store({
    state: {
        challengeStatus: ChallengeStatus_1.ChallengeStatus.Unknown,
        currentChallenge: { ChallengeTypeValue: ChallengeType_1.ChallengeType.Empty },
        challengeHistory: [{ ChallengeTypeValue: ChallengeType_1.ChallengeType.Empty }],
        configuration: {},
        errors: [],
        machineSecretProvider: {},
        nonce: null,
        progression: [ChallengeType_1.ChallengeType.Empty],
        isSubmittingChallenge: false,
        rememberDevice: false,
        deviceName: '',
        remainOnStepUpScreenOnFailure: false,
        rememberUsername: false,
        rememberedUsername: '',
        hasRememberedUsername: false,
        authenticatedModel: { username: '', nonce: '' },
        isSyncing: false,
        checkSyncResultChallenge: { ChallengeTypeValue: ChallengeType_1.ChallengeType.CheckSyncResult },
        showRememberDevice: false,
        isStepUpMandatory: false,
        currentWorkflowMaxSteps: 0,
        currentWorkflowStep: 0,
        isResendingOTP: false,
        isSubmittingAuthenticatedModel: false,
        turnstileToken: '',
        isCypress: false,
        username: '',
    },
    getters: {
        currentChallengeType: (state) => {
            return state.currentChallenge.ChallengeTypeValue;
        },
        currentChallenge: (state) => {
            return state.currentChallenge;
        },
        siteTextMap: (state) => {
            return state.configuration.siteTextMap;
        },
        debugSiteText: (state) => {
            return state.configuration.debugSiteText || false;
        },
        loginCredentials: (state) => {
            return state.configuration.loginCredentials;
        },
        rememberDevice: (state) => {
            return state.rememberDevice;
        },
        deviceName: (state) => {
            return state.deviceName;
        },
        remainOnStepUpScreenOnFailure: (state) => {
            return state.remainOnStepUpScreenOnFailure;
        },
        canRememberDevice: (state) => {
            const currentMachineSecretProvider = state.configuration.machineSecretProvider;
            return state.showRememberDevice && (currentMachineSecretProvider !== null && currentMachineSecretProvider !== '');
        },
        challengeStatus: (state) => {
            return state.challengeStatus;
        },
        rememberUsername: (state) => {
            return state.rememberUsername;
        },
        ellipsisConfig: (state) => {
            return JSON.parse(JSON.stringify(state.configuration.ellipsisConfig));
        },
        hasServerError: (state) => {
            return state.errors.length > 0;
        },
        hasInvalidChallengeStatus: (state) => {
            return state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown;
        },
        hasSessionExpiredError: (state) => {
            return state.challengeStatus === ChallengeStatus_1.ChallengeStatus.SessionExpired;
        },
        isSubmittingChallenge: (state) => {
            return state.isSubmittingChallenge;
        },
        authenticatedModel: (state) => {
            return state.authenticatedModel;
        },
        isSyncing: (state) => {
            return state.isSyncing;
        },
        checkSyncResultChallenge: (state) => {
            return state.checkSyncResultChallenge;
        },
        configuration: (state) => {
            return state.configuration;
        },
        challengeHistory: (state) => {
            return state.challengeHistory;
        },
        showRememberDevice: (state) => {
            return state.showRememberDevice;
        },
        isStepUpMandatory: (state) => {
            return state.isStepUpMandatory;
        },
        isMobile: (state) => {
            if (state.configuration.baseUrl)
                return state.configuration.baseUrl.toLowerCase().includes('mobile');
            return false;
        },
        isNativeApplication: (state) => {
            return state.configuration.isNativeApplication.toLowerCase() === 'true';
        },
        isForgotPasswordWorkflow: (state) => {
            if (state.currentChallenge) {
                const currentChallenge = state.currentChallenge;
                return currentChallenge.Progression.includes(ChallengeType_1.ChallengeType.StartForgotPassword);
            }
            return false;
        },
        isForgotUsernameWorkflow: (state) => {
            if (state.currentChallenge) {
                const currentChallenge = state.currentChallenge;
                return currentChallenge.Progression.includes(ChallengeType_1.ChallengeType.StartForgotUsername);
            }
            return false;
        },
        isRegistering: (state) => {
            if (state.currentChallenge) {
                const currentChallenge = state.currentChallenge;
                return currentChallenge.Progression.includes(ChallengeType_1.ChallengeType.StartRegistration);
            }
            return false;
        },
        workflow: (state, getters) => {
            if (getters.isForgotPasswordWorkflow)
                return Workflow_1.Workflow.ForgotPassword;
            else if (getters.isForgotUsernameWorkflow)
                return Workflow_1.Workflow.ForgotUsername;
            else if (getters.isRegistering)
                return Workflow_1.Workflow.Registration;
            return Workflow_1.Workflow.Authentication;
        },
        currentWorkflowMaxSteps: (state) => {
            return state.currentWorkflowMaxSteps;
        },
        currentWorkflowStep: (state) => {
            return state.currentWorkflowStep;
        },
        isResendingOTP: (state) => {
            return state.isResendingOTP;
        },
        isSubmittingAuthenticatedModel: (state) => {
            return state.isSubmittingAuthenticatedModel;
        },
        displayAccountOpeningLink: (state) => {
            var _a;
            return ((_a = state.configuration.displayAccountOpeningLink) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
        },
        displayForgotPasswordLink: (state) => {
            var _a;
            return ((_a = state.configuration.displayForgotPasswordLink) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
        },
        displayForgotUsernameLink: (state) => {
            var _a;
            return ((_a = state.configuration.displayForgotUsernameLink) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
        },
        enableAppStoreNavigationPrompt: (state) => {
            var _a;
            return ((_a = state.configuration.enableAppStoreNavigationPrompt) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
        },
        disableDesktopRegistration: (state) => {
            var _a;
            return ((_a = state.configuration.disableDesktopRegistration) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === 'true';
        },
        enableRememberMe: (state) => {
            var _a;
            return ((_a = state.configuration.enableRememberMe) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === 'true';
        },
        initialChallengeType: (state) => {
            return state.configuration.initialChallengeType;
        },
        username: (state) => {
            return state.username;
        },
    },
    mutations: {
        configuration: (state, configuration) => {
            state.configuration = configuration;
        },
        errors: (state, errors) => {
            state.errors = errors;
        },
        machineSecretProvider: (state, provider) => {
            state.machineSecretProvider = provider;
        },
        currentChallenge: (state, challengeType) => {
            state.currentChallenge = challengeType;
            state.challengeHistory.push(challengeType);
        },
        challengeStatus: (state, status) => {
            state.challengeStatus = status;
        },
        isSubmittingChallenge: (state, bool) => {
            state.isSubmittingChallenge = bool;
        },
        clearLoginCredentials: (state) => {
            state.configuration.loginCredentials = undefined;
        },
        setRememberDevice: (state, bool) => {
            state.rememberDevice = bool;
        },
        setDeviceName: (state, name) => {
            state.deviceName = name;
        },
        setRemainOnStepUpScreenOnFailure: (state, bool) => {
            state.remainOnStepUpScreenOnFailure = bool;
        },
        setRememberUsername: (state, rememberUsername) => {
            state.rememberUsername = rememberUsername;
        },
        updateEllipsisConfig: (state, ellipsisConfig) => {
            state.configuration.ellipsisConfig = ellipsisConfig;
        },
        setRememberedUsername: (state, rememberedUsername) => {
            state.rememberedUsername = rememberedUsername;
        },
        hasRememberedUsername: (state, hasRememberedUsername) => {
            state.hasRememberedUsername = hasRememberedUsername;
        },
        authenticatedModel: (state, authenticatedModel) => {
            state.authenticatedModel = authenticatedModel;
        },
        isSyncing: (state, isSyncing) => {
            state.isSyncing = isSyncing;
        },
        setShowRememberDevice: (state, showRememberDevice) => {
            state.showRememberDevice = showRememberDevice;
        },
        setIsStepUpMandatory: (state, isStepUpMandatory) => {
            state.isStepUpMandatory = isStepUpMandatory;
        },
        setCurrentWorkflowMaxSteps: (state, currentWorkflowMaxSteps) => {
            state.currentWorkflowMaxSteps = currentWorkflowMaxSteps;
        },
        setCurrentWorkflowStep: (state, currentWorkflowStep) => {
            state.currentWorkflowStep = currentWorkflowStep;
        },
        setIsResendingOTP: (state, resendingOTP) => {
            state.isResendingOTP = resendingOTP;
        },
        setIsSubmittingAuthenticatedModel: (state, submitting) => {
            state.isSubmittingAuthenticatedModel = submitting;
        },
        setTurnstileToken: (state, token) => {
            state.turnstileToken = token;
        },
        setTurnstileEnableState: (state, enabled) => {
            state.configuration.turnstileEnabled = enabled;
        },
        isCypress: (state, isCypress) => {
            state.isCypress = isCypress;
        },
        setUserName: (state, name) => {
            state.username = name;
        },
    },
    actions: {
        debug: (context, bool) => {
            context.commit('configuration', {
                ...context.state.configuration,
                debugSiteText: bool,
            });
            return;
        },
        initializeIsotope: async (context, payload) => {
            const configuration = payload.configuration;
            context.commit('configuration', configuration);
            return context.dispatch('submitChallenge', {});
        },
        submitChallenge: async (context, challenge) => {
            const challengeProcessor = new api_1.ChallengeProcessor(context, challenge);
            let response = null;
            try {
                response = await challengeProcessor.submitChallenge();
            }
            catch (error) {
                if (typeof error.json == 'function') {
                    try {
                        response = await error.json();
                    }
                    catch (ex) {
                        // Do nothing
                    }
                }
                else
                    response = error;
            }
            if (response == null || response.ChallengeStatusValue == null && response.ValidationResults == null) {
                context.commit('errors', [
                    {
                        CustomSubCode: '',
                        ErrorCode: 0,
                        Field: '',
                        ItemIndex: 0,
                        Message: 'An unknown error occurred.',
                        Origin: challenge.ChallengeTypeValue,
                        Severity: 1,
                        SubCode: 0,
                    },
                ]);
                context.commit('isSubmittingChallenge', false);
                return response;
            }
            return challengeProcessor.postSubmitChallenge(response);
        },
        goToPreviousChallenge: (context) => {
            const currentChallenge = context.state.challengeHistory.pop();
            let previousChallenge = context.state.challengeHistory.pop();
            while (currentChallenge.ChallengeTypeValue === previousChallenge.ChallengeTypeValue) {
                previousChallenge = context.state.challengeHistory.pop();
            }
            if (!currentChallenge ||
                currentChallenge.ChallengeTypeValue === ChallengeType_1.ChallengeType.Empty ||
                !previousChallenge ||
                previousChallenge.ChallengeTypeValue === ChallengeType_1.ChallengeType.Empty) {
                return;
            }
            const challenge = {
                ...currentChallenge,
                ...previousChallenge,
                Nonce: currentChallenge.Nonce,
                Progression: currentChallenge.Progression,
            };
            if (context.state.currentWorkflowMaxSteps > 0) {
                const previousStep = context.state.currentWorkflowStep - 1;
                context.commit('setCurrentWorkflowStep', previousStep);
            }
            context.commit('currentChallenge', challenge);
        },
        resetErrorStatus: (context) => {
            context.commit('errors', []);
            context.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        getRememberedUsername: async (context) => {
            try {
                const configuration = context.state.configuration;
                if (configuration.initialChallengeType !== ChallengeType_1.ChallengeType.Tethered) {
                    const rememberedUsername = await (0, api_1.GetRememberedUsername)(configuration);
                    if (rememberedUsername !== '')
                        context.commit('hasRememberedUsername', true);
                    context.commit('setRememberedUsername', rememberedUsername);
                }
            }
            catch (ex) {
                //
            }
        },
        setChallengeStatus: (context, status) => {
            context.commit('challengeStatus', status);
            return;
        },
        setRememberUsername: async (context, remember) => {
            var _a;
            context.commit('setRememberUsername', remember);
            // for native applications, call the remember me switch channel
            if (window.Alkami.Helpers.isNativeApplication() === true
                && typeof ((_a = window.f_rememberMeSwitch) === null || _a === void 0 ? void 0 : _a.postMessage) === 'function') {
                window.f_rememberMeSwitch.postMessage(JSON.stringify({ rememberMe: remember }));
            }
            if (!remember && context.state.hasRememberedUsername === true) {
                try {
                    context.commit('hasRememberedUsername', false);
                    const configuration = context.state.configuration;
                    await (0, api_1.RemoveRememberedUsername)(configuration);
                }
                catch (ex) {
                    // eslint-disable-next-line no-console
                    console.error('Error unsetting remember username', ex);
                    context.commit('hasRememberedUsername', true);
                }
            }
        },
    }, // Asynchronous actions that ultimately end in mutating state.
});
